/**
 * Created by PRIME AI.
 * @author Samuel Hinchliffe <samuel@primeai.co.uk, sam.hinchliffe.work@gmail.com>
 * @see    [Linkedin] {@link https://www.linkedin.com/in/samuel-hinchliffe-2bb5801a5/}
 *
 * @summary This is just a basic modal, with basic functions. The parent is expected
 * to provide it's styles, it's host and it';
 * Created at: 25/10/2023
 * @see       [PRIME-AI GITHUB] {@link https://github.com/PRIME-AI-GITHUB}
 * @see       [Website]         {@link https://www.primeai.co.uk/}
 * @copyright 2018-2023 PRIME AI LTD
*/

export default class Modal {
    static TEMPLATE = `
    <div modalRoot>
        <section class="background" root close> </section>
        <section class="modal" modal>
            <div class="modal-header">
                <h2 title></h2>
                <button class="close-btn" close>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="height: 20px;width: 20px;">
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                    </svg>
                </button>
            </div>
            <div class="modal-content" description></div>
            <div class="modal-footer"> 
            <button class="btn" close closeButton></button>
            </div>
        </section>
    </div>`;

    constructor(host, header, text, langs) {
        this.host = host;
        this.header = header;
        this.text = text;
        this.modalElement = null;
        this.langs = langs;

        this.render();
    }

    render() {
        const modalWrapper = document.createElement('div');
        modalWrapper.innerHTML = Modal.TEMPLATE;

        this.modalElement = modalWrapper.querySelector('[modalRoot]');
        this.modalElement.querySelector('h2').innerText = this.header;
        this.modalElement.querySelector('.modal-content').innerText = this.text;

        // Language update
        this.modalElement.querySelector('[closeButton]').innerHTML = this.langs.closeButton;

        const closeButtons = this.modalElement.querySelectorAll('[close]');

        for (const button of closeButtons) {
            button.addEventListener('click', this.hide.bind(this));
        }

        this.host.appendChild(modalWrapper.firstElementChild);
    }

    hide() {
        this.modalElement.style.opacity = '0';
        setTimeout(() => {
            this.modalElement.style.display = 'none';
        }, 300);
    }

    display() {
        this.modalElement.style.display = 'flex';
        setTimeout(() => {
            this.modalElement.style.opacity = '1';
        }, 10);
    }

    toggleDisplay() {
        const currentDisplay = window.getComputedStyle(this.modalElement).getPropertyValue('display');
        this.modalElement.style.display = currentDisplay === 'none' ? 'block' : 'none';
    }
}
